import { FC, ReactNode } from 'react'
import { Box, Flex } from '@chakra-ui/react'

interface IconBoxProps {
  boxSize: number
  iconSize: number
  borderRadius?: string
  bg?: string
  bgGradient?: string
  color?: string
  children: ReactNode
}

export const IconBox: FC<IconBoxProps> = ({
  boxSize,
  iconSize,
  borderRadius = '9px',
  bg,
  bgGradient,
  color,
  children,
}) => {
  const padding = (boxSize - iconSize) / 2

  return (
    <Flex
      w={`${boxSize}px`}
      h={`${boxSize}px`}
      minW={`${boxSize}px`}
      minH={`${boxSize}px`}
      borderRadius={borderRadius}
      bg={bg}
      bgGradient={bgGradient}
      color={color}
      align="center"
      justify="center"
      flexShrink={0}
      p={`${padding}px`}
      overflow="hidden"
    >
      <Box
        as="span"
        display="block"
        w={`${iconSize}px`}
        h={`${iconSize}px`}
        lineHeight={0}
        flexShrink={0}
        sx={{
          '& svg': {
            display: 'block',
            width: '100%',
            height: '100%',
          },
        }}
      >
        {children}
      </Box>
    </Flex>
  )
}
